import axiosInstance from "../axiosInstance";

export const provinceService = {
  create: async (data) => {
    try {
      let response = await axiosInstance.post("/province", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetch: async (searchValue, query, type, country, code = []) => {
    try {
      let api_query = `/province?`;

      // Search by dynamic field (e.g., name, code)
      if (searchValue?.trim()) {
        api_query += `&${type}[$search]=${searchValue.trim()}`;
      }

      // Filter by country ID
      if (country) {
        api_query += `&country=${country}`;
      }

      // Filter by province codes using $in
      if (code.length > 0) {
        api_query += code.map((x) => `&code[$in][]=${x}`).join("");
      }

      // Append any additional query string (sorting, filters, etc.)
      if (query?.length) {
        api_query += `&${query}`;
      }

      const response = await axiosInstance.get(api_query);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  get: async (id) => {
    try {
      let response = await axiosInstance.get(`/province/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  edit: async (data, id) => {
    try {
      let response = await axiosInstance.patch(`/province/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/province/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchProvinceName: async (searchKey, client_id, limit = 15, skip = 0) => {
    try {
      let query = `limit=${limit}&skip=${skip}`;
      if (client_id) {
        query += `&client_id=${client_id}`;
      }
      if (searchKey) {
        query += `&searchkey=${encodeURIComponent(searchKey)}`;
      }

      let response = await axiosInstance.get(`/fetch-province-name?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchProvinceCode: async (searchKey, client_id, limit = 15, skip = 0) => {
    try {
      let query = `limit=${limit}&skip=${skip}`;
      if (client_id) {
        query += `&client_id=${client_id}`;
      }
      if (searchKey) {
        query += `&searchkey=${encodeURIComponent(searchKey)}`;
      }

      let response = await axiosInstance.get(`/fetch-province-code?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
